/**
 * Utility functions for Cal.com integration
 */

/**
 * Formats slot time from ISO 8601 to readable "HH:mm" format
 * Uses user's timezone automatically
 */
export function formatSlotTime(isoString: string): string {
  const date = new Date(isoString);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return date.toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: userTimeZone,
  });
}

/**
 * Formats a slot range with start and end times
 * Example: "09:00 - 09:30"
 */
export function formatSlotRange(start: string, end: string): string {
  return `${formatSlotTime(start)} - ${formatSlotTime(end)}`;
}

/**
 * Gets user timezone in IANA format
 */
export function getUserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Formats a date for Cal.com booking title
 */
export function formatBookingTitle(userName: string, slotStart: string): string {
  const startLocal = new Date(slotStart);
  const formattedStart = startLocal.toLocaleString('fr-FR', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
  return `Tournage PRSNL - ${userName} - ${formattedStart}`;
}

